import React from "react";

import { useList } from "@refinedev/core";

import { facetCounts } from "@/pages/areas/lib/area-hits";
import { type CityOption, citiesFromFacet } from "@/pages/areas/lib/cities";

/**
 * The city picker's options: every city that has an area, read as the `cityKey` facet of
 * `GET /areas/explore` — the same facet `/areas` builds its own city box from. Only a city
 * with areas can have an area finding, so this is the exact domain of the filter.
 *
 * Not `useAreaCities` from `/areas` itself: that hook's typed `select` is outside the
 * typecheck gate and red inside it, and this needs only the facet, not the rows. A failed
 * read leaves the list empty, which still offers "All cities".
 */
export const useAreaAuditCities = (): CityOption[] => {
  const { result } = useList({
    resource: "areas",
    dataProviderName: "areas",
    pagination: { currentPage: 1, pageSize: 1 },
    meta: { query: "*", queryBy: "name,aliases", facetBy: ["cityKey"] },
    errorNotification: false,
  });
  const facets = (result as { facets?: unknown } | undefined)?.facets;
  return React.useMemo(
    () => citiesFromFacet(facetCounts(facets, "cityKey")),
    [facets],
  );
};
